var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiSrCustomerfocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AAB3BE",
    d: "M11.968 9.73a8.145 8.145 0 0 1 7.044-1.36c.017-.2.036-.388.036-.587a7.1 7.1 0 1 0-14.2-.001v.001c0 .2.019.399.037.598a8.175 8.175 0 0 1 7.083 1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#182F43",
    d: "M11.219 13.836c.496.06.997.057 1.493-.006a6.171 6.171 0 0 0-.748-1.308 6.2 6.2 0 0 0-.745 1.314Zm9.827-3.364a7.092 7.092 0 0 0-1.246-.718 8.133 8.133 0 0 1-4.668 5.462c.042.323.064.649.066.975a8.041 8.041 0 0 1-2.44 5.785 7.09 7.09 0 0 0 8.288-11.504Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAB3BE",
    d: "M8.741 16.19c.001-.319.022-.638.063-.955a8.116 8.116 0 0 1-4.706-5.443 7.091 7.091 0 1 0 7.104 12.205 8.04 8.04 0 0 1-2.46-5.806Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#182F43",
    d: "M13.192 15.783a8.118 8.118 0 0 1-2.445.007 6.056 6.056 0 0 0 1.222 4.081 6.055 6.055 0 0 0 1.223-4.088Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAB3BE",
    d: "M9.286 13.28a8.094 8.094 0 0 1 1.235-2.154 6.12 6.12 0 0 0-4.234-1.015 6.142 6.142 0 0 0 3 3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374957",
    d: "M13.416 11.126a8.05 8.05 0 0 1 1.228 2.138 6.153 6.153 0 0 0 2.958-3.154 6.09 6.09 0 0 0-4.186 1.016Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrCustomerfocus);
export default __webpack_public_path__ + "static/media/fi-sr-customer focus.030f4c93770d9b9bbce2185ceec9ceb6.svg";
export { ForwardRef as ReactComponent };